<template>
    <!-- Proxy login on My Proxies: username + password, or an IP whitelist (the same fields as ProProxies) -->
    <div class="modal fade" id="authenticationModal" tabindex="-1" aria-hidden="true" ref="modalEl">
        <div class="modal-dialog modal-dialog-centered w-[460px]">
            <div class="modal-content">
                <form @submit.prevent="save">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">Proxy login</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" v-if="props.license">
                        <ProxyLoginFields v-model="login" :host="props.license.host_domain" :port="props.license.http_port" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="submit" :disabled="busy || !valid" class="btn btn-primary">Save login</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, defineProps, defineEmits } from 'vue';
import { useProxyStore } from "@/stores"
import ProxyLoginFields from '@/components/Customer/ProxyLoginFields.vue';
import { loginFrom, loginValid, loginToAuth } from '@/helpers/proxyLogin';

const props = defineProps({ license: { type: Object, required: true } });
const emit = defineEmits(['inInput', 'submit', 'close'])
const proxyStore = useProxyStore()
const busy = ref(false)

// the licence's login as it is now; opening the window again starts from it again
const login = ref(loginFrom())
const reset = () => { login.value = loginFrom(props.license?.authentication_user, props.license?.authorization_ips) }
watch(() => props.license, reset, { immediate: true })
const modalEl = ref(null)
onMounted(() => modalEl.value && modalEl.value.addEventListener('show.bs.modal', reset))
onBeforeUnmount(() => modalEl.value && modalEl.value.removeEventListener('show.bs.modal', reset))

const valid = computed(() => loginValid(login.value, 1))
const save = async () => {
    if (!valid.value || !props.license) return
    busy.value = true
    const { auth_user, auth_ips } = loginToAuth(login.value)
    await proxyStore.updateUserAuthentication(props.license.uuid, auth_user, auth_ips)
    busy.value = false
    emit('close')
}
</script>
